import { render } from "./addDouyinCodeModule.vue?vue&type=template&id=3263141f"
import script from "./addDouyinCodeModule.vue?vue&type=script&lang=js"
export * from "./addDouyinCodeModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__